<template>
  <div class="top">
    <div class="top-right" style="float:right;padding:17px 17px 0">
      <Button
        type="primary"
        class="search-button"
        style="margin-left:10px;"
        @click="payMoney"
      >付款</Button>
  </div>
  </div>
</template>

<script>
export default {
  props: {
    orderDetail: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      loading: true,
      resetLostForm: {
        reason: ''
      }
    }
  },
  methods: {
    payMoney (event) {
      this.$Modal.confirm({
        title: '确认付款',
        content: `<p>代理付款金额${this.orderDetail.customer_price}元将从账户余额中扣除</p>`,
        onOk: () => {
          let url = `/order/pay`
          let data = {
            orderId: this.orderDetail.id
          }
          this.$http.put(url, data).then(res => {
            if (res.success) {
              this.$Message.success('确认付款')
              this.$router.back()
            } else {
              this.$Message.warning(res.message)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/handle/agOrderPay/OrderDetailTop.vue